import { createFileRoute } from '@tanstack/react-router'
import { UserSecurityPage } from '../../../../components/auth/UserSecurityPage'

export const Route = createFileRoute('/$org/user/me/security')({
    component: UserSecurityRoute,
})

function UserSecurityRoute() {
    const { org } = Route.useParams()
    return <UserSecurityPage org={org} />
}
